module.exports = __webpack_public_path__ + "img/c_bg_zhibo.b4cf073f.png";